import { useState } from 'react';
import { supabasePortal as supabase } from '../lib/supabase';
import { i18n, LANG_LABELS, detectLang } from './portalI18n';

const CARD_STYLE = {
  background: 'white', borderRadius: 20, padding: '48px 40px',
  maxWidth: 420, width: '90%', textAlign: 'center',
  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
};

export default function PortalResetPasswordPage({ onSuccess }) {
  const [lang, setLang] = useState(detectLang);
  const t = i18n[lang];

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError(t.passwordMismatch); return; }
    if (password.length < 6) { setError(t.passwordTooShort); return; }
    setBusy(true);
    setError('');
    try {
      const { data, error: updateErr } = await supabase.auth.updateUser({ password });
      if (updateErr) throw updateErr;
      setDone(true);
      setTimeout(() => onSuccess(data.user?.session || data.session), 1500);
    } catch (err) {
      setError(err.message || t.loginError);
    } finally {
      setBusy(false);
    }
  };

  const textAlign = lang === 'en' ? 'left' : 'right';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1e3a8a 0%, #4338ca 100%)',
      fontFamily: "'Segoe UI', -apple-system, sans-serif",
      direction: t.dir,
    }}>
      <div style={CARD_STYLE}>
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 24 }}>
          {Object.entries(LANG_LABELS).map(([code, label]) => (
            <button key={code} onClick={() => { setLang(code); localStorage.setItem('portal_lang', code); }} style={{
              padding: '4px 10px', borderRadius: 20, border: '1px solid',
              borderColor: lang === code ? '#4338ca' : '#e2e8f0',
              background: lang === code ? '#4338ca' : 'white',
              color: lang === code ? 'white' : '#64748b',
              cursor: 'pointer', fontSize: 12, fontWeight: 600,
            }}>{label}</button>
          ))}
        </div>

        <div style={{ fontSize: 48, marginBottom: 12 }}>🔐</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', margin: '0 0 28px' }}>
          {done ? t.passwordChanged : t.newPasswordTitle}
        </h1>

        {!done && (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ textAlign }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }}>
                {t.newPasswordLabel}
              </label>
              <input
                type="password" required value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                style={inputStyle} dir="ltr"
              />
            </div>
            <div style={{ textAlign }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }}>
                {t.confirmNewPassword}
              </label>
              <input
                type="password" required value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="••••••••"
                style={inputStyle} dir="ltr"
              />
            </div>
            {error && (
              <div style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '10px 14px', fontSize: 13 }}>
                {error}
              </div>
            )}
            <button type="submit" disabled={busy} style={{
              padding: '13px', borderRadius: 10, border: 'none',
              background: busy ? '#a5b4fc' : '#4338ca',
              color: 'white', fontSize: 15, fontWeight: 700,
              cursor: busy ? 'default' : 'pointer',
            }}>
              {busy ? t.settingPassword : t.setPasswordBtn}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '10px 14px',
  border: '1.5px solid #e2e8f0', borderRadius: 10,
  fontSize: 14, outline: 'none', boxSizing: 'border-box',
};
